"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M5.67867 17.8966C6.9613 18.6 8.43394 19 10 19C12.6655 19 15.0604 17.8412 16.7083 16L11.8974 14.1526C11.658 14.0607 11.5 13.8307 11.5 13.5743V13.5743C11.5 13.2223 11.6989 12.9006 12.0137 12.7432L12.5682 12.4659C13.1498 12.1751 13.5462 11.6112 13.6229 10.9654L13.8657 8.92064C14.0096 7.70881 13.5859 6.49842 12.7176 5.64088L12.6344 5.55867C11.9476 4.88036 11.0212 4.5 10.0559 4.5V4.5C9.09844 4.5 8.17888 4.87426 7.49353 5.5429L7.38863 5.64524C6.51108 6.50138 6.07105 7.71048 6.19304 8.93039L6.39511 10.9511C6.46041 11.6041 6.85589 12.1779 7.44281 12.4714L7.98634 12.7432C8.30114 12.9006 8.5 13.2223 8.5 13.5743V13.5743C8.5 13.8307 8.34199 14.0607 8.10259 14.1526L3.29168 16C1.86656 14.4077 1 12.3051 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 11.3029 18.7231 12.5411 18.2251 13.6591",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

exports.default = Icon;